import React from 'react'
import { observer } from 'mobx-react-lite'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import s from '../NoteTakerDrawer.module.scss'

const SessionConflictBanner = observer(() => {
	if (!noteTakerStore.sessionDrawerConflict) return null

	return (
		<div className={s.conflictBanner}>
			<span>This note was updated elsewhere. Reload to continue.</span>
			<button type="button" onClick={() => noteTakerStore.reloadSessionDrawerFromServer()}>
				Reload
			</button>
		</div>
	)
})

export default SessionConflictBanner
